var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#0096DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.333 36.1667H36.6663V26.8333H29.6663V36.1667H31.9997V29.1667H34.333V36.1667ZM17.9997 36.1667V18.6667C17.9997 18.3572 18.1226 18.0605 18.3414 17.8417C18.5602 17.6229 18.8569 17.5 19.1663 17.5H35.4997C35.8091 17.5 36.1058 17.6229 36.3246 17.8417C36.5434 18.0605 36.6663 18.3572 36.6663 18.6667V24.5H38.9997V36.1667H40.1663V38.5H16.833V36.1667H17.9997ZM22.6663 26.8333V29.1667H24.9997V26.8333H22.6663ZM22.6663 31.5V33.8333H24.9997V31.5H22.6663ZM22.6663 22.1667V24.5H24.9997V22.1667H22.6663Z",
    fill: "#0096DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCity);
export default __webpack_public_path__ + "static/media/Icon_city.d291ecc1f326978b56e1b0ae56cc244b.svg";
export { ForwardRef as ReactComponent };